export const Patterns = {
    EMAILADDRESS: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    PASSWORD: /^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]))(?=.*\d)(?=.*[?#$^+=!*(){}[\]:;<>,.~_\-@%&/\\]).{6,39}/
};
